<div class="cv-pool-container p-3">
  <div class="row mb-4">
    <div class="col-md-12">
      <h2 class="mb-4">CV Pool - Job Categories</h2>
      <div class="d-flex justify-content-between align-items-center">
        <p>
          Manage job categories and their CVs. Create categories, upload CVs, and find the best matches using AI.
        </p>
        <div>
          <button class="btn btn-primary" (click)="openCategoryModal()">
            <i class="bi bi-plus-circle"></i> New Category
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Job Categories List -->
  <div class="row mb-4">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0">Job Categories</h5>
        </div>
        <div class="card-body">
          <div *ngIf="isLoadingCategories" class="text-center p-3">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <div *ngIf="jobCategories$ | async as categories" class="row">
            <div *ngFor="let category of categories" class="col-md-6 col-lg-4 mb-3">
              <div class="card h-100 category-card" 
                   [class.border-primary]="selectedCategory?.id === category.id"
                   [class.selected]="selectedCategory?.id === category.id"
                   (click)="selectCategory(category)">
                <div class="card-body position-relative">
                  <!-- Delete Button -->
                  <button class="btn btn-sm btn-outline-danger category-action-btn delete-category-btn"
                          (click)="deleteCategory(category, $event)"
                          title="Kategori Sil">
                    <i class="bi bi-trash"></i>
                  </button>

                  <!-- Edit Button -->
                  <button class="btn btn-sm btn-outline-secondary category-action-btn edit-category-btn" 
                          (click)="editCategory(category, $event)"
                          title="Edit Category">
                    <i class="bi bi-pencil"></i>
                  </button>
                  
                  <h6 class="card-title">{{ category.title }}</h6>
                  <p class="card-text text-muted small">{{ category.description || 'No description' }}</p>
                  
                  <div class="row text-center">
                    <div class="col-4">
                      <div class="text-primary fw-bold">{{ category.cvCount }}</div>
                      <div class="small text-muted">Total CVs</div>
                    </div>
                    <div class="col-4">
                      <div class="text-success fw-bold">{{ category.analyzedCvCount }}</div>
                      <div class="small text-muted">Analyzed</div>
                    </div>
                    <div class="col-4">
                      <div class="text-warning fw-bold">{{ category.pendingCvCount }}</div>
                      <div class="small text-muted">Pending</div>
                    </div>
          </div>

                  <div *ngIf="category.recentCVs && category.recentCVs.length > 0" class="mt-2">
                    <div class="small text-muted">Recent CVs:</div>
                    <div *ngFor="let cv of category.recentCVs" class="small">
                      {{ cv.applicantName }} 
                      <span [class]="getStatusBadgeClass(cv.status)" class="ms-1">
                        {{ cv.status }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
          </div>

  <!-- Selected Category CVs -->
  <div *ngIf="selectedCategory" class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0">{{ selectedCategory.title }} - CVs</h5>
            <div>
            <button class="btn btn-success btn-sm me-2 upload-main-btn" (click)="openUploadModal()">
              <i class="bi bi-upload"></i> Upload CV
              </button>
            <button class="btn btn-primary btn-sm" (click)="openScoringModal()">
              <i class="bi bi-star"></i> Score CVs
              </button>
            </div>
        </div>
        <div class="card-body">
          <!-- Filters -->
          <div class="row mb-3">
            <div class="col-md-6">
              <input type="text" class="form-control" placeholder="Search CVs..." 
                     [(ngModel)]="searchTerm">
            </div>
            <div class="col-md-3">
              <select class="form-select" [(ngModel)]="cvStatusFilter">
                <option value="">All Status</option>
                <option value="completed">Completed</option>
                <option value="processing">Processing</option>
                <option value="pending">Pending</option>
                <option value="failed">Failed</option>
              </select>
            </div>
          </div>

          <!-- CVs List -->
          <div *ngIf="isLoadingCVs" class="text-center p-3">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <div *ngIf="!isLoadingCVs" class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                  <th>Score</th>
                  <th>Applicant</th>
                  <th>Contact</th>
                  <th>File</th>
                  <th>Status</th>
                  <th>Uploaded</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                <tr *ngFor="let cv of filteredCVs">
                  <td>
                    <ng-container *ngIf="cv.totalScore !== null && cv.totalScore !== undefined; else noScore">
                      <span [class]="getScoreBadgeClass(cv.totalScore)" class="px-2 py-1">
                        {{ cv.totalScore }}/100
                      </span>
                      <div class="text-muted small" *ngIf="cv.scoredAt">
                        {{ cv.scoredAt | date:'short' }}
                      </div>
                    </ng-container>
                    <ng-template #noScore>
                      <span class="text-muted small">No score</span>
                    </ng-template>
                  </td>
                  <td>
                    <div class="fw-bold">{{ cv.applicantName }}</div>
                    <div class="small text-muted">{{ cv.applicantEmail || 'No email' }}</div>
                  </td>
                  <td>
                    <div *ngIf="cv.applicantPhone" class="small">{{ cv.applicantPhone }}</div>
                    <div *ngIf="!cv.applicantPhone" class="text-muted small">No phone</div>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <div class="small">{{ cv.fileName }}</div>
                      <button *ngIf="cv.hasFile"
                              type="button"
                              class="btn btn-link p-0"
                              (click)="openCVFile(cv)"
                              title="Dosyayı görüntüle"
                              aria-label="Dosyayı yeni sekmede aç">
                        <i class="bi bi-box-arrow-up-right"></i>
                      </button>
                    </div> 
                    <div class="text-muted small">{{ formatFileSize(cv.fileSize) }}</div>
                    </td>
                    <td>
                    <span [class]="getStatusBadgeClass(cv.analysisStatus)">
                      <span *ngIf="cv.analysisStatus === 'processing'" class="spinner-border spinner-border-sm me-1"></span>
                      {{ cv.analysisStatus }}
                      </span>
                    </td>
                    <td>
                    <div class="small">{{ cv.uploadedAt | date:'short' }}</div>
                    <div class="text-muted small">by {{ cv.uploadedBy?.username || 'Unknown' }}</div>
                    </td>
                    <td>
                    <div class="btn-group btn-group-sm" role="group">
                      <button class="btn btn-outline-primary btn-sm" 
                              (click)="viewCVAnalysis(cv)"
                              [disabled]="cv.analysisStatus !== 'completed'"
                              title="View Analysis"
                              [class.disabled]="cv.analysisStatus !== 'completed'">
                        <i class="bi bi-eye"></i>
                      </button>
                      <button class="btn btn-outline-warning btn-sm" 
                              (click)="reanalyzeCV(cv)"
                              [disabled]="cv.analysisStatus === 'processing'"
                              title="Re-analyze"
                              [class.disabled]="cv.analysisStatus === 'processing'">
                        <i class="bi bi-arrow-clockwise"></i>
                      </button>
                      <button class="btn btn-outline-danger btn-sm" 
                              (click)="deleteCV(cv)"
                              title="Delete CV">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>


<!-- Category Modal -->
<div class="modal fade" [class.show]="showCategoryModal" [style.display]="showCategoryModal ? 'block' : 'none'">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Create Job Category</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
          </div>
      <div class="modal-body">
        <form [formGroup]="categoryForm">
          <div class="mb-3">
            <label class="form-label">Category Title *</label>
            <input type="text" class="form-control" formControlName="title" placeholder="e.g., Senior Backend Developer">
        </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea class="form-control" formControlName="description" rows="3" 
                      placeholder="Job description and requirements..."></textarea>
            </div>
          <div class="mb-3">
            <label class="form-label">Requirements</label>
            <textarea class="form-control" formControlName="requirements" rows="2" 
                      placeholder="Specific requirements and qualifications..."></textarea>
            </div>
        </form>
          </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModals()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createCategory()">Create Category</button>
        </div>
      </div>
    </div>
  </div>

<!-- Edit Category Modal -->
<div class="modal fade" [class.show]="showEditCategoryModal" [style.display]="showEditCategoryModal ? 'block' : 'none'">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Job Category</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="editCategoryForm">
          <div class="mb-3">
            <label class="form-label">Category Title *</label>
            <input type="text" class="form-control" formControlName="title" placeholder="e.g., Senior Backend Developer">
          </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea class="form-control" formControlName="description" rows="3" 
                      placeholder="Job description and requirements..."></textarea>
          </div>
          <div class="mb-3">
            <label class="form-label">Requirements</label>
            <textarea class="form-control" formControlName="requirements" rows="2" 
                      placeholder="Specific requirements and qualifications..."></textarea>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModals()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateCategory()" [disabled]="isUpdatingCategory">
          <span *ngIf="isUpdatingCategory" class="spinner-border spinner-border-sm me-2"></span>
          Update Category
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Upload Modal -->
<div class="modal fade" [class.show]="showUploadModal" [style.display]="showUploadModal ? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
        <h5 class="modal-title">Upload CV(s)</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
        </div>
        <div class="modal-body">
            <div class="mb-3">
          <label class="form-label">CV Files *</label>
          <input type="file" class="form-control" accept=".pdf,.doc,.docx" multiple
                 (change)="onFileSelect($event)">
          <div class="form-text">
            <i class="bi bi-info-circle me-1"></i>
            Select one or multiple CV files. AI will automatically extract all information from each CV.
              </div>
            </div>
            
        <!-- Selected Files List -->
        <div *ngIf="selectedFiles.length > 0" class="mb-3">
          <h6>Selected Files ({{ selectedFiles.length }}):</h6>
          <div class="list-group">
            <div *ngFor="let file of selectedFiles; let i = index" class="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <i class="bi bi-file-pdf text-danger me-2"></i>
                {{ file.name }}
                <small class="text-muted ms-2">({{ formatFileSize(file.size) }})</small>
              </div>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeFile(i)">
                <i class="bi bi-x"></i>
              </button>
            </div>
              </div>
            </div>
            
        <div class="text-center">
          <button type="button" class="btn btn-primary upload-btn" (click)="uploadFiles()" 
                  [disabled]="selectedFiles.length === 0 || isUploading">
            <span *ngIf="isUploading" class="spinner-border spinner-border-sm me-2"></span>
            <i class="bi bi-upload me-1"></i>
            Upload {{ selectedFiles.length }} CV(s)
          </button>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModals()">Close</button>
        </div>
            </div>
              </div>
            </div>
            
<!-- CV Analysis Modal -->
<div class="modal fade" [class.show]="showCVAnalysisModal" [style.display]="showCVAnalysisModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        <h5 class="modal-title">CV Analysis - {{ cvAnalysis?.applicantName }}</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
        </div>
        <div class="modal-body">
        <div *ngIf="isLoadingAnalysis" class="text-center p-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            
        <div *ngIf="cvAnalysis && !isLoadingAnalysis">
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  <h6 class="mb-0">Contact Information</h6>
                </div>
                <div class="card-body">
                  <div><strong>Name:</strong> {{ cvAnalysis.applicantName }}</div>
                  <div><strong>Email:</strong> {{ cvAnalysis.applicantEmail || 'Not provided' }}</div>
                  <div><strong>Phone:</strong> {{ cvAnalysis.applicantPhone || 'Not provided' }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  <h6 class="mb-0">File Information</h6>
            </div>
                <div class="card-body">
                  <div><strong>File:</strong> {{ cvAnalysis.fileName }}</div>
                <!--  <div><strong>Size:</strong> {{ formatFileSize(cvAnalysis.fileSize) }}</div> -->
                  <div><strong>Status:</strong> 
                    <span [class]="getStatusBadgeClass(cvAnalysis.analysisStatus)">
                      {{ cvAnalysis.analysisStatus }}
                    </span>
        </div>
        </div>
      </div>
    </div>
  </div>

          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">AI Analysis Summary</h6>
            </div>
            <div class="card-body">
              <div [innerHTML]="cvAnalysis.summary"></div>
            </div>
        </div>
        </div>
              </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModals()">Close</button>
              </div>
            </div>
              </div>
            </div>
            
<!-- Matching Modal -->
<div class="modal fade" [class.show]="showMatchingModal" [style.display]="showMatchingModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        <h5 class="modal-title">Find Best Matches</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
        </div>
        <div class="modal-body">
        <form [formGroup]="matchingForm">
            <div class="mb-3">
            <label class="form-label">Job Description *</label>
            <textarea class="form-control" formControlName="description" rows="6" 
                      placeholder="Describe the job position, requirements, and what you're looking for..."></textarea>
            <div class="form-text">AI will analyze all CVs in this category and find the best matches.</div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModals()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="performMatching()" 
                [disabled]="!matchingForm.valid || isLoadingMatches">
          <span *ngIf="isLoadingMatches" class="spinner-border spinner-border-sm me-2"></span>
          Find Matches
          </button>
        </div>
      </div>
    </div>
  </div>

<!-- CV Scoring Modal -->
<div class="modal fade" [class.show]="showScoringModal" [style.display]="showScoringModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
        <h5 class="modal-title">AI CV Scoring</h5>
        <button type="button" class="btn-close" (click)="closeModals()"></button>
        </div>
        <div class="modal-body">
        <div *ngIf="!scoringResults">
          <div class="alert alert-info">
            <h6>Job Description:</h6>
            <p>{{ selectedCategory?.description || 'No description available' }}</p>
          </div>
          
          <!-- Loading State -->
          <div *ngIf="isLoadingScoring" class="text-center py-4">
            <div class="spinner-border text-primary mb-3" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <h6 class="text-muted">AI is analyzing CVs...</h6>
            <p class="small text-muted">This may take a few moments</p>
            </div>
            
          <!-- Start Button -->
          <div *ngIf="!isLoadingScoring" class="text-center">
            <button class="btn btn-primary btn-sm scoring-btn" (click)="performScoring()">
              <i class="bi bi-star-fill me-1"></i>
              Start Scoring
            </button>
                </div>
              </div>
              
        <div *ngIf="scoringResults">
          <div class="row mb-4">
            <div class="col-md-8">
              <h6>Job Position: {{ selectedCategory?.title }}</h6>
              <p class="text-muted">{{ selectedCategory?.description }}</p>
                </div>
            <div class="col-md-4 text-end">
              <span class="badge bg-primary fs-6">{{ scoringResults.scores.length || 0 }} CVs Scored</span>
              <button class="btn btn-outline-warning btn-sm ms-2" (click)="reScoreCVs()" [disabled]="isLoadingScoring">
                <span *ngIf="isLoadingScoring" class="spinner-border spinner-border-sm me-1"></span>
                <i class="bi bi-arrow-clockwise me-1"></i>
                Re-score
              </button>
              <div class="small text-muted mt-2" *ngIf="scoringResults.totalCVs !== undefined">
                Total CVs: {{ scoringResults.totalCVs }} | Scored: {{ scoringResults.scoredCVs || scoringResults.scores.length || 0 }}
              </div>
              <div class="small text-muted" *ngIf="scoringResults.scoredAt">
                Last scored: {{ scoringResults.scoredAt | date: 'short' }}
              </div>
              </div>
            </div>
            
          <div class="alert alert-success">
            <h6>📊 Scoring Summary</h6>
            <p>{{ scoringResults.summary }}</p>
              </div>
              
          <!-- Top 5 Candidates -->
          <div class="card mb-4">
            <div class="card-header">
              <h6 class="mb-0">⭐ Top 5 Candidates</h6>
            </div>
            <div class="card-body">
            <div class="row">
                <div *ngFor="let score of scoringResults.scores.slice(0, 5); let i = index" class="col-12 mb-3">
                  <div class="card border-0 shadow-sm">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-start mb-2">
                        <h6 class="mb-0">{{ i + 1 }}. {{ score.applicantName }}</h6>
                        <span [class]="getScoreBadgeClass(score.totalScore)">{{ score.totalScore }}/100</span>
                      </div>
                      <div class="small text-muted mb-2">{{ score.recommendation }}</div>
                      <div class="progress mb-2" style="height: 6px;">
                        <div class="progress-bar" [class]="score.totalScore >= 90 ? 'bg-success' : score.totalScore >= 80 ? 'bg-warning' : 'bg-info'" 
                             [style.width.%]="score.totalScore"></div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                </div>
              </div>
              
          <!-- Detailed Scoring -->
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">🎯 All Candidates Ranking ({{ scoringResults.scores.length || 0 }} Total)</h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Candidate</th>
                      <th>Total Score</th>
                      <th>Technical</th>
                      <th>Experience</th>
                      <th>Education</th>
                      <th>Leadership</th>
                      <th>Communication</th>
                      <th>Recommendation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let score of scoringResults.scores; let i = index">
                      <td><span class="badge bg-secondary">{{ i + 1 }}</span></td>
                      <td>
                        <div class="fw-bold">{{ score.applicantName }}</div>
                      </td>
                      <td>
                        <span [class]="getScoreBadgeClass(score.totalScore)">{{ score.totalScore }}/100</span>
                      </td>
                      <td>{{ score.breakdown.technicalSkills }}</td>
                      <td>{{ score.breakdown.experience }}</td>
                      <td>{{ score.breakdown.education }}</td>
                      <td>{{ score.breakdown.leadership }}</td>
                      <td>{{ score.breakdown.communication }}</td>
                      <td>
                        <div class="recommendation-cell">
                          <span class="badge bg-info">{{ getShortRecommendation(score.recommendation) }}</span>
                          <button class="btn btn-sm btn-outline-info ms-2" 
                                  (click)="showFullRecommendation(score.recommendation, score.applicantName)"
                                  title="View full recommendation">
                            <i class="bi bi-eye"></i>
                          </button>
              </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModals()">Close</button>
        <button *ngIf="scoringResults" type="button" class="btn btn-primary" (click)="performScoring()" [disabled]="isLoadingScoring">
          <span *ngIf="isLoadingScoring" class="spinner-border spinner-border-sm me-1"></span>
          <i class="bi bi-arrow-clockwise me-1" *ngIf="!isLoadingScoring"></i> Re-score
        </button>
                </div>
              </div>
              </div>
            </div>
            
<!-- Success Popup Modal -->
<div class="modal fade" [class.show]="showSuccessModal" [style.display]="showSuccessModal ? 'block' : 'none'">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg">
      <div class="modal-body text-center p-4">
            <div class="mb-3">
          <i class="bi bi-check-circle-fill text-success" style="font-size: 3rem;"></i>
            </div>
        <h5 class="mb-3">Success!</h5>
        <p class="text-muted mb-4">{{ successMessage }}</p>
        <button type="button" class="btn btn-success" (click)="closeModals()">
          <i class="bi bi-check me-1"></i> OK
        </button>
              </div>
              </div>
              </div>
            </div>
            
<!-- Confirm Popup Modal -->
<div class="modal fade" [class.show]="showConfirmModal" [style.display]="showConfirmModal ? 'block' : 'none'">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg">
      <div class="modal-body text-center p-4">
            <div class="mb-3">
          <i class="bi bi-exclamation-triangle-fill text-warning" style="font-size: 3rem;"></i>
        </div>
        <h5 class="mb-3">Confirm Action</h5>
        <p class="text-muted mb-4">{{ confirmMessage }}</p>
        <div class="d-flex gap-2 justify-content-center">
          <button type="button" class="btn btn-outline-secondary" (click)="cancelAction()">
            <i class="bi bi-x me-1"></i> Cancel
          </button>
          <button type="button" class="btn btn-danger" (click)="confirmAction()">
            <i class="bi bi-check me-1"></i> Confirm
          </button>
        </div>
        </div>
                </div>
              </div>
            </div>
            
<!-- Recommendation Modal -->
<div class="modal fade" [class.show]="showRecommendationModal" [style.display]="showRecommendationModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="bi bi-person-badge me-2"></i>
          Recommendation for {{ candidateName }}
        </h5>
        <button type="button" class="btn-close" (click)="closeRecommendationModal()"></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-info">
          <h6><i class="bi bi-lightbulb me-2"></i>AI Recommendation</h6>
        </div>
        <div class="recommendation-content">
          <p class="lead">{{ fullRecommendation }}</p>
            </div>
        </div>
        <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeRecommendationModal()">
          <i class="bi bi-x me-1"></i> Close
          </button>
        </div>
      </div>
    </div>
  </div>

<!-- Toast Notification -->
<div *ngIf="showToast" class="toast-notification" [class]="'toast-' + toastType">
  <div class="toast-content">
    <i [class]="toastType === 'success' ? 'bi bi-check-circle-fill' : toastType === 'error' ? 'bi bi-exclamation-triangle-fill' : 'bi bi-info-circle-fill'"></i>
    <div class="toast-message" [innerHTML]="formatToastMessage(toastMessage)"></div>
    <button type="button" class="btn-close" (click)="hideToast()">
      <i class="bi bi-x"></i>
    </button>
  </div>
</div> 

<!-- Backdrop -->
        <div *ngIf="showCategoryModal || showEditCategoryModal || showUploadModal || showCVAnalysisModal || showMatchingModal || showScoringModal || showSuccessModal || showConfirmModal || showRecommendationModal" 
             class="modal-backdrop fade show"></div>
